import { adminConstants } from '../constant/admin-constant';

const initialState = {loading: false, newCompany: '', editCompany:'', message:''};
export function companyReducer(state = initialState, action){

	switch(action.type){

		case adminConstants.GET_COMPANY_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_COMPANY_SUCCESS:
			return { loading:false, editCompany : action.payload.company };
		case adminConstants.GET_COMPANY_FAILURE:
			return { loading:false, error : action.payload };

		case adminConstants.STORE_COMPANY_REQUEST:
			return { ...state, loading:true }
		case adminConstants.STORE_COMPANY_SUCCESS:
			return { loading:false };
		case adminConstants.STORE_COMPANY_FAILURE:
			return { loading:false, error:action.payload };


		case adminConstants.EDIT_COMPANY_REQUEST:
			return { ...state, loading:true }
		case adminConstants.EDIT_COMPANY_SUCCESS:
			return { ...state, loading:false };
		case adminConstants.EDIT_COMPANY_FAILURE:
			return { ...state, loading:false, error:action.payload };


		case adminConstants.DELETE_COMPANY_REQUEST:
			return { ...state, loading:true }
		case adminConstants.DELETE_COMPANY_SUCCESS:
			return { ...state, loading:false };
		case adminConstants.DELETE_COMPANY_FAILURE:
			return { loading:false, error:action.payload };


			
		case adminConstants.PAGINATION_COMPANY_REQUEST:
			return { ...state, loading:true }
		case adminConstants.PAGINATION_COMPANY_SUCCESS:
			return {  
				data: action.payload.company.data,
        		pages : action.payload.company.last_page,
        		//firstLoginFlag : true,
        		loading: false 
        	};
		case adminConstants.PAGINATION_COMPANY_FAILURE:
			return { loading:false, error:action.payload };


		// case adminConstants.STORE_COMPANY_USER_REQUEST:
		// 	return { ...state, loading:true }
		// case adminConstants.STORE_COMPANY_USER_SUCCESS:
		// 	return { ...state, loading:false, editCompanyUser:'' };
		// case adminConstants.STORE_COMPANY_USER_FAILURE:
		// 	return { ...state, loading:false, error:action.payload };

		// case adminConstants.GET_COMPANY_USER_REQUEST:
		// 	return { ...state, loading:true };
		// case adminConstants.GET_COMPANY_USER_SUCCESS:
		// 	return { ...state, loading:false, editCompanyUser : action.payload };
		// case adminConstants.GET_COMPANY_USER_FAILURE:
		// 	return { loading:false, error : action.payload };


		// case adminConstants.GET_COMPANY_USERS_REQUEST:
		// 	return { ...state, loading:true };
		// case adminConstants.GET_COMPANY_USERS_SUCCESS:
		// 	return { ...state, loading:false , companyUsers:action.payload.company};
		// case adminConstants.GET_COMPANY_USERS_FAILURE:
		// 	return { loading:false, error : action.payload };

	
		// case adminConstants.EDIT_COMPANY_USER_REQUEST:
		// 	return { ...state, loading:true };
		// case adminConstants.EDIT_COMPANY_USER_SUCCESS:
		// 	return { ...state, loading:false , editCompanyUser:action.payload};
		// case adminConstants.EDIT_COMPANY_USER_FAILURE:
		// 	return { loading:false, error : action.payload };



		// case adminConstants.DELETE_COMPANY_USER_REQUEST:
		// 	return { ...state, loading:true }
		// case adminConstants.DELETE_COMPANY_USER_SUCCESS:
		// 	return { ...state, loading:false, editCompanyUser:'' };
		// case adminConstants.DELETE_COMPANY_USER_FAILURE:
		// 	return { loading:false, error:action.payload };

		case adminConstants.GET_COMPANY_PROFILE_INFO_REQUEST:
			return { ...state, loading:true };
		case adminConstants.GET_COMPANY_PROFILE_INFO_SUCCESS:
			return { loading:false, companyInfo : action.payload.company };
		case adminConstants.GET_COMPANY_PROFILE_INFO_FAILURE:
			return { loading:false, error : action.payload };

		case adminConstants.GET_COMPANY_ALL_USERS_REQUEST:
			return { ...state, loading:true }
		case adminConstants.GET_COMPANY_ALL_USERS_SUCCESS:
			return {  
				companyUsersData: action.payload.allCompanyUsers.data,
        		companyUsersPages : action.payload.allCompanyUsers.last_page,
        		//firstLoginFlag : true,
        		loading: false 
        	};
		case adminConstants.GET_COMPANY_ALL_USERS_FAILURE:
			return { loading:false, error:action.payload };
			
		default:
			return { ...state };
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/CompanyReducer.jsx